import React from "react";
import DivisionCmp from "../../components/cards/DivisionCmp";
import Grid from "@mui/material/Grid";
import CardHintCmp from "../../components/cardHint/cardHintCmp";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import * as Yup from "yup";
import { Button } from "@mui/material";
import { ChangePasswordRequest } from "../../models/security.model";
import { debug } from "console";
import { useMutation } from "react-query";
import { changeUserPassword } from "../../services/security.service";
import { toast } from "react-toastify";
import { ApiResultModel } from "../../models/common.model";
import { useHistory } from "react-router-dom";
import MaterialPasswordField from "../../components/textField/MaterialPasswordField";

interface PasswordSample {
  oldPassword: string | undefined;
  newPassword: string | undefined;
  repeatNewPassword: string | undefined;
}
const UserProfileCmp = () => {
  let initialValues = {} as PasswordSample;

  const passwordValidation = Yup.object().shape({
    // oldPassword: Yup.string()
    //   .required("لطفا رمز عبور قبلی را وارد نمایید.")
    //   .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
    newPassword: Yup.string()
      .ensure()
      .required("لطفا رمز عبور جدید را وارد نمایید.")
      .matches(/^(?=.*[a-z])/, "باید شامل یک حرف کوچک باشد")
      .matches(/^(?=.*[A-Z])/, "باید شامل یک حرف بزرگ باشد")
      .matches(/^(?=.*[0-9])/, "باید شامل یک عدد باشد.")
      .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
    repeatNewPassword: Yup.string()
      .ensure()
      .oneOf([Yup.ref("newPassword"), null], "با رمز عبور جدید یکسان نیست.")
      .required("لطفا رمز عبور جدید را مجددا تکرا نمایید."),
    // .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
  });

  const history = useHistory();

  const changeUserPass = useMutation(changeUserPassword, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (!data.isSuccess) {
        if (data.messages != null && data.messages.length > 0) {
          toast.error(data.messages[0]);
        } else {
          toast.error("خطا در برقراری ارتباط با سرویس");
        }
      } else {
        toast.success("رمز عبور با موفقیت تغییر یافت ");
        history.push("welcome");
      }
    },
    onError: () => {},
  });

  return (
    <Grid
      container
      spacing={0}
      style={{ paddingTop: "20px", paddingLeft: "30px" }}
      columns={{ xs: 4, sm: 6, md: 12 }}
    >
      <Grid item xs={2} style={{ display: "flex", justifyContent: "center" }}>
        <img
          src="images/userProfileIcon.png"
          style={{ objectFit: "contain" }}
        />
      </Grid>
      <Grid item xs={10} style={{ marginTop: "10px" }}>
        <CardHintCmp
          icon={
            <WarningAmberIcon sx={{ color: "#1D4A87", marginLeft: "10px" }} />
          }
          title={
            "رمزی که انتخاب میکنید باید به زبان انگلیسی و حداقل شامل یک حرف بزرگ، یک حرف کوچک و یک عدد و حداقل 8 کاراکتر باشد."
          }
          fontSize={"12px"}
        />
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={10}>
        <Formik
          initialValues={initialValues}
          validateOnMount={true}
          validationSchema={passwordValidation}
          onSubmit={async (values) => {
            let changePass = {} as ChangePasswordRequest;
            changePass.oldPassword = values.oldPassword!;
            changePass.newPassword = values.newPassword!;
            changeUserPass.mutateAsync(changePass);
          }}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
          }) => (
            <form
              onSubmit={handleSubmit}
              // onKeyDown={(e) => {
              //   if (e.key === "Enter") {
              //     handleSubmit();
              //   }
              // }}
            >
              <div>
                <Grid
                  container
                  // spacing={{ xs: 2, md: 3 }}
                  columns={{ xs: 4, sm: 8, md: 12 }}
                  style={{
                    paddingTop: "20px",
                    paddingBottom: "10px",
                    rowGap: "20px",
                  }}
                >
                  <Grid item xs={4} style={{ marginTop: "10px" }}>
                    <MaterialPasswordField
                      // helperText={touched.oldPassword ? errors.oldPassword : ""}
                      // error={touched.oldPassword && Boolean(errors.oldPassword)}
                      placeHolder={"رمز قبلی"}
                      label={"رمز قبلی"}
                      required={true}
                      value={values.oldPassword}
                      onChange={handleChange}
                      name="oldPassword"
                      id="oldPassword"
                      autoFocus={true}
                      type="password"
                    />
                  </Grid>
                  <Grid item xs={8} />
                  <Grid item xs={4} style={{ marginTop: "10px" }}>
                    <MaterialPasswordField
                      helperText={touched.newPassword ? errors.newPassword : ""}
                      error={touched.newPassword && Boolean(errors.newPassword)}
                      placeHolder={"رمز جدید"}
                      label={"رمز جدید"}
                      required={true}
                      value={values.newPassword}
                      onChange={handleChange}
                      name="newPassword"
                      id="newPassword"
                      onBlur={handleBlur}
                      type="password"
                    />
                  </Grid>
                  <Grid item xs={8} />
                  <Grid item xs={4} style={{ marginTop: "10px" }}>
                    <MaterialPasswordField
                      helperText={
                        touched.repeatNewPassword
                          ? errors.repeatNewPassword
                          : ""
                      }
                      error={
                        touched.repeatNewPassword &&
                        Boolean(errors.repeatNewPassword)
                      }
                      placeHolder={"تکرار رمز جدید"}
                      label={"تکرار رمز جدید"}
                      required={true}
                      value={values.repeatNewPassword}
                      onChange={handleChange}
                      name="repeatNewPassword"
                      id="repeatNewPassword"
                      onBlur={handleBlur}
                      type="password"
                    />
                  </Grid>
                  <Grid item xs={8} />

                  <Grid item xs={10} />
                  <Grid
                    item
                    xs={2}
                    style={{ direction: "rtl", marginTop: "20px" }}
                  >
                    <Button
                      fullWidth
                      type="submit"
                      disabled={Object.keys(errors).length > 0}
                      className={`${
                        Object.keys(errors).length > 0
                          ? "btnForm disabledBtn  "
                          : "btnForm SuccessDefault  "
                      }`}
                    >
                      تغییر رمز ورود
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>
          )}
        </Formik>
      </Grid>
    </Grid>
  );
};

export default function userProfilePage() {
  const child = <UserProfileCmp />;
  return (
    <DivisionCmp
      child={child}
      title="  تغییر رمز ورود "
      marginTop={"1vh"}
      marginBottom={"1vh"}
    />
  );
}
